import { render, staticRenderFns } from "./BankAccountWrap.vue?vue&type=template&id=1dec0c03"
import script from "./BankAccountWrap.vue?vue&type=script&lang=js"
export * from "./BankAccountWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports